import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { PortfolioInboxes } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { PopulationBasedFundingPortfolioTable } from "@/Portfolio/Components/PopulationBasedFunding/PopulationBasedFundingPortfolioTable";
import { IAPSSInboxModel } from "@/Portfolio/Models/UI/IAPSSInboxModel";
import { IConsultationRequestInboxModel } from "@/Portfolio/Models/UI/IConsultationRequestsInboxModel";
import { IConsultationRequestPopupDataModel } from "@/Portfolio/Models/UI/IConsultationRequestsPopupDataModel";
import { INotesInboxModel } from "@/Portfolio/Models/UI/INotesInboxModel";
import { IPendingApprovalInboxModel } from "@/Portfolio/Models/UI/IPendingApprovalInboxModel";
import { IPortalSyncModel } from "@/Portfolio/Models/UI/IPortalSyncModel";
import { IPortfolioTabModel } from "@/Portfolio/Models/UI/IPortfolioTabModel";
import { IPreventiveActivitiesInboxModel } from "@/Portfolio/Models/UI/IPreventiveActivitiesInboxModel";
import { IPreventiveRecallListModel } from "@/Portfolio/Models/UI/IPreventiveRecallListModel";
import { ILabRequestsInboxModel } from "@/Portfolio/Models/UI/IRequestsInboxModel";
import { ISentFaxInboxModel } from "@/Portfolio/Models/UI/ISentFaxInboxModel";
import { PortfolioPageRegistryView } from "./Extensions/PortfolioPageRegistry";
import { ApssInbox } from "./APSSInbox";
import { ConseilNumeriqueInbox } from "./ConseilNumeriqueInbox";
import { ConsultationRequestInbox } from "./ConsultationRequestInbox";
import { ExamRequestsInbox } from "./ExamRequestsInbox";
import { NotesInbox } from "./NotesInbox";
import { PendingApprovalInbox } from "./PendingApprovalInbox";
import { PortalPendingItems } from "./PortalPendingItems";
import { PortalSyncHistory } from "./PortalSyncHistory";
import { PortfolioFaxInbox } from "./PortfolioFaxInbox";
import { PortfolioTreeControl } from "./PortfolioTreeControl";
import { PreventiveActivitiesInbox } from "./PreventiveActivitiesInbox";
import { PreventiveRecallList } from "./PreventiveRecallList";

class PortfolioTabState {
    public model: IPortfolioTabModel;
    public notesInboxModel: INotesInboxModel;
    public consultationRequestsInboxModel: IConsultationRequestInboxModel;
    public requestsInboxModel: ILabRequestsInboxModel;
    public consultationRequestPopupDataModel: IConsultationRequestPopupDataModel;
    public sentFaxInboxModel: ISentFaxInboxModel;
    public failedFaxInboxModel: ISentFaxInboxModel;
    public pendingApprovalInboxModel: IPendingApprovalInboxModel;
    public apssInboxModel: IAPSSInboxModel;
    public portalSyncModel: IPortalSyncModel;
    public preventiveActivitiesInboxModel: IPreventiveActivitiesInboxModel;
    public preventiveRecallListModel: IPreventiveRecallListModel;

    public constructor(init?: Partial<PortfolioTabState>) {
        Object.assign(this, init);
    }
}

class PortfolioTab extends React.Component<EmptyProps, PortfolioTabState> {
    public constructor(props: EmptyProps) {
        super(props);
        this.state = this.getCurrentStateFromStore();
    }

    private changeListenerMethodId: string;

    private getPageElement(): JSX.Element {
        switch (this.state.model.get("CurrentInbox")) {
            case PortfolioInboxes.Extension:
                return (
                    <PortfolioPageRegistryView componentId={this.state.model.get("CurrentExtensionId")} />
                );
            case PortfolioInboxes.Notes:
                return (
                    <NotesInbox
                        Model={this.state.notesInboxModel}
                    />
                );

            case PortfolioInboxes.ConsultationRequests:
                return (
                    <ConsultationRequestInbox
                        Model={this.state.consultationRequestsInboxModel}
                        ConsultationRequestPopupModel={this.state.consultationRequestPopupDataModel}
                    />
                );

            case PortfolioInboxes.Requests:
                return (
                    <ExamRequestsInbox
                        model={this.state.requestsInboxModel}
                    />
                );

            case PortfolioInboxes.Faxes:
                return (
                    <PortfolioFaxInbox
                        title={cacheStore.GetString("MySentFaxLabel")}
                        model={this.state.sentFaxInboxModel}
                        inboxType={this.state.model.get("CurrentInbox")}
                    />
                );

            case PortfolioInboxes.FailedFaxes:
                return (
                    <PortfolioFaxInbox
                        title={cacheStore.GetString("FailedFaxesLabel")}
                        model={this.state.failedFaxInboxModel}
                        inboxType={this.state.model.get("CurrentInbox")}
                    />
                );

            case PortfolioInboxes.PendingApprovals:
                return (
                    <PendingApprovalInbox
                        Model={this.state.pendingApprovalInboxModel}
                    />
                );

            case PortfolioInboxes.APSS_Recent:
            case PortfolioInboxes.APSS_Purges:
                return (
                    <ApssInbox
                        Model={this.state.apssInboxModel}
                        Type={this.state.model.get("CurrentInbox")}
                    />
                );

            case PortfolioInboxes.APSS_ConseilNumerique:
                return (
                    <ConseilNumeriqueInbox
                        Model={this.state.apssInboxModel}
                    />
                );
            case PortfolioInboxes.PortalSyncItemsErrors:
            case PortfolioInboxes.PortalPendingItems:
                return cacheStore.ClinicSettings_Portal.EnablePortalWebsite
                    ? <PortalPendingItems model={this.state.portalSyncModel} />
                    : <div />;

            case PortfolioInboxes.PortalSyncItems:
                return cacheStore.ClinicSettings.EnablePortfolioPortalSyncHistory && cacheStore.ClinicSettings_Portal.EnablePortalWebsite
                    ? <PortalSyncHistory model={this.state.portalSyncModel} />
                    : <div />;

            case PortfolioInboxes.PreventiveActivities:
                return (
                    <PreventiveActivitiesInbox
                        model={this.state.preventiveActivitiesInboxModel}
                    />
                );

            case PortfolioInboxes.PopulationBasedFunding:
                return <PopulationBasedFundingPortfolioTable />;

            case PortfolioInboxes.PreventiveRecallList:
                return <PreventiveRecallList model={this.state.preventiveRecallListModel} />;

            default:
                return <div />;
        }
    }

    public render(): JSX.Element {
        return (
            <div className="sub-container">
                <div className="left-nav-menu transition" style={{ minWidth: "auto", maxWidth: "250px", whiteSpace: "nowrap", overflow: "hidden" }}>
                    <PortfolioTreeControl
                        notesCount={portfolioStore.Model.get("NotesCount")}
                        currentInbox={portfolioStore.Model.get("CurrentInbox")}
                        apssRecentCount={portfolioStore.Model.get("ApssRecentCount")}
                        apssPurgeCount={portfolioStore.Model.get("ApssPurgeCount")}
                        apssConseilNumeriqueCount={portfolioStore.Model.get("ApssConseilNumeriqueCount")}
                        supervisionNoteCount={portfolioStore.Model.get("SupervisionNoteCount")}
                        failedFaxesCount={portfolioStore.Model.get("FailedFaxesCount")}
                        failedSharedItemsCount={portfolioStore.Model.get("FailedSharedItemsCount")}
                    />
                </div>
                {this.getPageElement()}
            </div>
        );
    }

    public componentDidMount(): void {
        this.changeListenerMethodId = portfolioStore.AddChangeListener(this.changeListener, this, "portfolio-tab-listener");
        sessionStore.dispatch(LocalOperations.Portfolio.PortfolioTab_didMount);
    }

    public componentWillUnmount(): void {
        portfolioStore.RemoveChangeListener(this.changeListenerMethodId);
    }

    public getCurrentStateFromStore(): PortfolioTabState {
        return {
            model: portfolioStore.Model,
            notesInboxModel: portfolioStore.NotesInboxModel,
            consultationRequestsInboxModel: portfolioStore.ConsultationRequestsInboxModel,
            requestsInboxModel: portfolioStore.RequestsInboxModel,
            sentFaxInboxModel: portfolioStore.sentFaxInboxModel,
            failedFaxInboxModel: portfolioStore.failedFaxInboxModel,
            consultationRequestPopupDataModel: portfolioStore.ConsultationRequestPopupDataModel,
            pendingApprovalInboxModel: portfolioStore.PendingApprovalInboxModel,
            apssInboxModel: portfolioStore.apssInboxModel,
            portalSyncModel: portfolioStore.portalSyncModel,
            preventiveActivitiesInboxModel: portfolioStore.preventiveActivitiesInboxModel,
            preventiveRecallListModel: portfolioStore.preventiveRecallListModel
        };
    }

    public changeListener(): void {
        this.setState(this.getCurrentStateFromStore());
    }
}

export { PortfolioTab };
